const Home = resolve => require(['../Index'], resolve);

export default [{
    name: 'dashboard.home',
    path: '/',
    component: Home,
    meta: {
      requiresAuth: true,
      title: 'Início',
      menu: true,
      icon: 'fa fa-home',
    }
  }
];



// WEBPACK FOOTER //
// ./src/pages/dashboard/routes/index.js